<template>
  <div>
    <ejs-grid
      :dataSource="rundata"
      ref="rungrid"
      height="calc(100vh - 276px)"
      :allowResizing="true"
      allowPaging="true"
    >
      <e-columns>
        <e-column
          field="neName"
          :headerText="$t('Software.td_neID')"
          width="15%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
        <e-column
          field="neType"
          :headerText="$t('Software.td_neName')"
          width="10%"
          clipMode="EllipsisWithTooltip"
          :valueAccessor="deviceTypeFormatter"
        ></e-column>
        <e-column
          field="cabinetId"
          :headerText="$t('Software.query_cabinetId')"
          width="10%"
          clipMode="EllipsisWithTooltip"
          :valueAccessor="typeFormat"
        ></e-column>
        <e-column
          field="frameId"
          :headerText="$t('Software.query_frameId')"
          width="10%"
          clipMode="EllipsisWithTooltip"
          :valueAccessor="typeFormat"
        ></e-column>
        <e-column
          field="slotId"
          :headerText="$t('Software.query_slotId')"
          width="10%"
          clipMode="EllipsisWithTooltip"
          :valueAccessor="typeFormat"
        ></e-column>
        <e-column
          field="appVersion"
          :headerText="$t('Software.query_appVersion')"
          width="25%"
          clipMode="EllipsisWithTooltip"
          :valueAccessor="typeFormat"
        ></e-column>
        <e-column
          field="detail"
          :headerText="$t('Software.query_remarks')"
          width="15%"
          clipMode="EllipsisWithTooltip"
        ></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>

<script>
export default {
  name: "QueryRunVersion",
  data() {
    return {
      rundata: [],
      deviceTypeMap: new Map() // 设备码和类型对应关系
        .set(10001, this.$t("Topo.devEPC"))
        .set(10002, this.$t("Topo.devhytalkPro"))
        .set(10003, this.$t("Topo.devMCS"))
        .set(10004, this.$t("Topo.deveNodeB"))
        .set(10005, this.$t("Topo.deveNodeBIOPS"))
        .set(10006, this.$t("Topo.deviBS"))
        .set(10007, this.$t("Topo.deviBSB"))
        .set(10008, this.$t("Topo.devODBBU"))
        .set(10009, this.$t("Topo.devgNB"))
        .set(10010, this.$t("Topo.devhytalk")),
    };
  },
  methods: {
    queryRunVersionOne(param) {
      //运行版本查询
      console.log("param==", param);
      this.axios
        .post("/lte/ems/verquery_new/queryRunVerByNeId", [param.id])
        .then((response) => {
          if (response.data.errorCode == "SUCCESS") {
            console.log("response.data.resultVal", response.data.resultVal);
            this.rundata = response.data.resultVal;
          }
        });
    },
    typeFormat(field, data, column) {
      if (data[field] === null || data[field] === "") {
        return "---";
      }
      return data[field];
    },
    // 格式化设备类型
    deviceTypeFormatter(field, devData) {
      return this.deviceTypeMap.get(devData["typeCode"]);
    },
  },
};
</script>

